module.exports = __webpack_public_path__ + "media/Michael.b403410f.mp3";